import DOMPurify from 'dompurify';
import $ from 'jquery';
import Cookies from 'js-cookie';
import moment from 'moment';

import {
  COMMENT_CONTAINER_SELECTOR,
  COMMENT_REPLY_CONTAINER_SELECTOR,
} from 'constants/comments';
import { KEY_ANON_COMMENT } from 'constants/cookie';
import { EMBED_PLAY_VIDEO_AT_TS } from 'constants/messages';
import { placeCaretAtEnd } from 'utilities/dom';
import { shorthandTimestampMomentConfig } from 'utilities/time';
import { goToNewTab } from 'utilities/url';

const ALLOWED_TAGS = ['a', 'b', 'br', 'p', 'div', 'u', 'i', 'span'];

const ALLOWED_ATTRIBUTES = ['href', 'data-seconds', 'class', 'target'];

const NO_HTML_SANITATION_BEFORE = '2018-02-15T22:00:00-0000';

export const getFormattedDateForHeader = createdAt => {
  moment.updateLocale('en', shorthandTimestampMomentConfig());

  return `${moment().from(createdAt, true)}`;
};

export const playVideoAtTimestamp = e => {
  e.preventDefault();
  e.stopPropagation();

  if (e.target.className.indexOf('external-link') > -1) {
    return goToNewTab(e.target.href);
  }

  const secondsData = e.target.getAttribute('data-seconds');

  if (!secondsData) {
    return;
  }

  const numSeconds = Number(secondsData);

  window.top.postMessage(
    {
      type: EMBED_PLAY_VIDEO_AT_TS,
      numSeconds,
    },
    '*'
  );

  return false;
};

export const sanitizeContent = comment => {
  if (moment(comment.createdAt).isBefore(NO_HTML_SANITATION_BEFORE)) {
    return comment.content;
  }

  const sanitizedContent = DOMPurify.sanitize(comment.content, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ALLOWED_ATTRIBUTES,
  });

  return sanitizedContent;
};

export const userCanDelete = (comment, currentUserIsOwner, user) => {
  if (currentUserIsOwner) {
    return true;
  } else if (user.is_logged_in) {
    return comment.user_id === user.current.id;
  }

  return Cookies.get(KEY_ANON_COMMENT) === comment.anon_user_id;
};

export const addMention = (result, query, elClass, mentions, trigger) => {
  const commentDiv = $(elClass)[0];

  if (!commentDiv) {
    return;
  }

  const dummyDiv = document.createElement('div');
  const mentionHTML = `<span class='mention' contentEditable="false">${trigger}${result.name}</span> `;

  dummyDiv.innerHTML = commentDiv.innerHTML;

  if (dummyDiv.lastChild && dummyDiv.lastChild.innerText) {
    dummyDiv.lastChild.innerText = dummyDiv.lastChild.innerText.slice(
      0,
      -1 * query.length
    );
    dummyDiv.lastChild.innerHTML = `${dummyDiv.lastChild.innerHTML}${mentionHTML}`;
  } else {
    dummyDiv.innerHTML = dummyDiv.innerHTML.slice(0, -1 * query.length);
    dummyDiv.innerHTML = `${dummyDiv.innerHTML}${mentionHTML}`;
  }

  commentDiv.innerHTML = dummyDiv.innerHTML;

  placeCaretAtEnd(commentDiv);

  return {
    ...mentions,
    [`${trigger}${result.name}`]: `${trigger}${result.id}`,
  };
};

export const calculateInlineEmbedDimensions = containerWidth => {
  const width = Math.round(0.8 * containerWidth);
  const height = Math.round((9 / 16) * width);

  return { width, height };
};

export const updateAllEmbedWidths = () => {
  document.querySelectorAll(COMMENT_CONTAINER_SELECTOR).forEach(node => {
    const containerWidth = node.offsetWidth;

    node.querySelectorAll('iframe').forEach(node => {
      const { width, height } = calculateInlineEmbedDimensions(containerWidth);

      node.width = width;
      node.height = height;
    });
  });
  document.querySelectorAll(COMMENT_REPLY_CONTAINER_SELECTOR).forEach(node => {
    const containerWidth = node.offsetWidth;

    node.querySelectorAll('iframe').forEach(node => {
      const { width, height } = calculateInlineEmbedDimensions(containerWidth);

      node.width = width;
      node.height = height;
    });
  });
};
